import {
  CupsDetail,
  SuppliesDetailObject,
} from "../../../core/models/suppliesDetail/suppliesDetail.model";

const formatCupsDetail = ({
  RazonSocial,
  Potencias,
  CodigoCUPS,
  EntornoTexto,
  Distribuidora,
  Tarifa,
  Calle,
  Numero,
  CodPostal,
  Municipio,
  IsActivo,
  MetodosPago,
  Envios,
  Contactos,
  Aclarador,
  CodigoContrato,
  Caudales,
  CodPostalTitular,
  CalleTitular,
  AclaradorTitular,
  NumeroTitular,
  Provincia,
}: CupsDetail): SuppliesDetailObject => {
  const getPhones = Contactos.filter(
    ({ TipoContacto }) => TipoContacto === "T",
  );
  const getEmails = Contactos.find(({ TipoContacto }) => TipoContacto === "E");
  const phones =
    getPhones.length > 0
      ? getPhones.map(({ ValorContacto }) => ValorContacto)
      : ["-"];
  const emails = getEmails ? getEmails.ValorContacto.split(";") : ["-"];

  return {
    socialReason: RazonSocial,
    powers: Potencias?.map(
      ({ PotenciaContratada, IdContratoPotencia, TextoPotencia }) => ({
        hiredPower: PotenciaContratada,
        idHiredPower: IdContratoPotencia,
        textPower: TextoPotencia,
        period: +TextoPotencia.replace("P", ""),
      }),
    ).sort((a, b) => a.period - b.period),
    flows: Caudales?.map(
      ({ PotenciaContratada, IdContratoPotencia, TextoPotencia }) => ({
        hiredPower: PotenciaContratada,
        idHiredPower: IdContratoPotencia,
        textPower: TextoPotencia,
        period: +TextoPotencia.replace("RL.", ""),
      }),
    ).sort((a, b) => a.period - b.period),
    codeContract: CodigoContrato,
    cupsCode: CodigoCUPS,
    service: EntornoTexto,
    distributor: Distribuidora,
    rate: Tarifa,
    address: Calle,
    holderAddress: CalleTitular,
    addressNumber: Numero ? Numero : "",
    holderAddressNumber: NumeroTitular,
    zipCode: CodPostal,
    province: Provincia,
    holderZipCode: CodPostalTitular,
    town: Municipio,
    contractSituation: IsActivo ? "Vigente" : "No vigente",
    clarifier: Aclarador,
    holderClarifier: AclaradorTitular,
    paymentMethod: {
      name: MetodosPago[0]?.NombrePagador || "-",
      collective: MetodosPago[0]?.ColectivoPagador || "-",
      cif: MetodosPago[0]?.IdentificadorPagador || "-",
      typeOfPayment: MetodosPago[0]?.TipoCobroPagador || "-",
      iban: MetodosPago[0]?.IBANPagador.replace(/.{0,6}$/, "******") || "-",
      bank: MetodosPago[0]?.BancoPagador || "-",
    },
    deliveryAddress: {
      data: Envios[0]?.NombreEnvio || "-",
      town: Envios[0]?.PoblacionEnvio || "-",
      zipCode: Envios[0]?.CodigoPostalEnvio || "-",
      address: Envios[0]?.DireccionEnvio || "-",
      addressNumber: Envios[0]?.NumeroEnvio || "-",
      clarifier: Envios[0]?.AclaradorEnvio || "-",
    },
    contact: {
      emails: emails,
      phones: phones,
    },
  };
};

const initialSuppliesDetail: SuppliesDetailObject = {
  codeContract: "-",
  socialReason: "-",
  powers: [],
  cupsCode: "-",
  service: "-",
  distributor: "-",
  rate: "-",
  address: "-",
  holderAddress: "-",
  addressNumber: "-",
  holderAddressNumber: "_",
  zipCode: "-",
  province: "-",
  holderZipCode: "-",
  town: "-",
  contractSituation: "-",
  clarifier: "-",
  holderClarifier: "-",
  paymentMethod: {
    name: "-",
    collective: "-",
    cif: "-",
    typeOfPayment: "-",
    iban: "-",
    bank: "-",
  },
  deliveryAddress: {
    data: "-",
    town: "-",
    zipCode: "-",
    address: "-",
    addressNumber: "-",
    clarifier: "-",
  },
  contact: {
    emails: ["-"],
    phones: ["-"],
  },
  flows: [],
};

const formatSuppliesDirection = (
  suppliesDetail: SuppliesDetailObject,
): string =>
  `${suppliesDetail.address} ${suppliesDetail.addressNumber} ${suppliesDetail.clarifier}`;

const formatSuppliesDirectionHolder = (
  suppliesDetail: SuppliesDetailObject,
): string =>
  `${suppliesDetail.holderAddress} ${suppliesDetail.holderAddressNumber} ${suppliesDetail.holderClarifier}`;

export {
  formatCupsDetail,
  initialSuppliesDetail,
  formatSuppliesDirection,
  formatSuppliesDirectionHolder,
};
